import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SadfaceMessageComponent } from './sadface-message/sadface-message.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private dialog: MatDialog) { }
  title = 'anw-stats';

  ngOnInit() {
    //this.dialog.open(SadfaceMessageComponent, { width: '500px', disableClose: true })
  }

}
